import {AddonPreview} from './AddonPreview';
export default AddonPreview;